import { useEntitlement } from '@components/entitlements';
import type { TourConfig } from '@features/app-tour/app-tour.models';
import artifactAnalysisSteps from '@features/app-tour/tour-steps/artifact-analysis-steps';
import imageSteps from '@features/app-tour/tour-steps/image-steps';
import kubernetesSteps from '@features/app-tour/tour-steps/kubernetes-steps';
import policyEditorSteps from '@features/app-tour/tour-steps/policy-editor-steps';
import policyManagerSteps from '@features/app-tour/tour-steps/policy-manager-steps';
import reportsSteps from '@features/app-tour/tour-steps/reports-steps';
import welcomeSteps from '@features/app-tour/tour-steps/welcome-steps';

export const useTourConfig = (): TourConfig => ({
  '/*': [welcomeSteps()],
  '/policy': [policyManagerSteps()],
  '/policy/:policyId': [policyEditorSteps()],
  '/inventory/kubernetes': [kubernetesSteps()],
  '/artifacts/image': [
    imageSteps({
      isCloudImage: useEntitlement('crp'),
    }),
  ],
  '/reports': [reportsSteps()],
  '/reports/new': [reportsSteps()],
  '/artifacts/image/:registry/:repository/:tag/:id': [artifactAnalysisSteps()],
});
